<section class="dp-stats">
  <div class="container">
    <div class="title text-center" [ngClass]="{'tamil': locale === 'ta'}" i18n="dbStats: title">Best Results With <span class="highlight"
        style="background-image: url('./assets/highlights/1.png'); font-family: 'Poppins Bold';">DP Education</span>
    </div>
    <div class="desc text-center" i18n="dbStats: desc">
      DP Education unlocks the digital door to premier learning for everyone, at no cost. We're pioneers in
      amplifying human potential, ensuring that the digital realm of education is universally accessible.
    </div>
    <div class="stats-primary d-flex align-items-center justify-content-center gap-5 my-5">
      <div class="stat d-flex align-items-center justify-content-between gap-3">
        <div class="icon"><img src="./assets/icons/stat/1.png" alt=""></div>
        <div class="stat-text" i18n="dbStats: Equitable access to learning">Equitable access to learning</div>
      </div>
      <div class="stat d-flex align-items-center justify-content-between gap-3">
        <div class="icon"><img src="./assets/icons/stat/5.png" alt=""></div>
        <div class="stat-text" i18n="dbStats: Learn at no cost">Learn at no cost</div>
      </div>
      <div class="stat d-flex align-items-center justify-content-between gap-3">
        <div class="icon"><img src="./assets/icons/stat/2.png" alt=""></div>
        <div class="stat-text" i18n="dbStats: Free quality online education">Quality online education</div>
      </div>
      <div class="stat d-flex align-items-center justify-content-between gap-3">
        <div class="icon"><img src="./assets/icons/stat/3.png" alt=""></div>
        <div class="stat-text" i18n="dbStats: World class curriculum">World class curricula</div>
      </div>
      <div class="stat d-flex align-items-center justify-content-between gap-3">
        <div class="icon"><img src="./assets/icons/stat/4.png" alt=""></div>
        <div class="stat-text" i18n="dbStats: Personalized learning">Personalized learning</div>
      </div>
    </div>

    <div class="stats-secondary d-flex align-items-center justify-content-between">
      <div class="stat">
        <div class="count">{{stat?.students | thousandSeparator}} +</div>
        <div class="stat-text" i18n="dbStats: reach">Reach</div>
      </div>

      <!-- <div class="stat">
        <div class="count">200 000</div>
        <div class="stat-text" i18n="dbStats: engagement">Engagement</div>
      </div> -->

      <div class="stat">
        <div class="count">{{stat?.subjects | thousandSeparator}} +</div>
        <div class="stat-text" i18n="dbStats: study materials">Study Materials</div>
      </div>

      <div class="stat">
        <div class="count">{{stat?.hours | thousandSeparator}} +</div>
        <div class="stat-text" i18n="dbStats: learning hours">Learning Hours</div>
      </div>
    </div>
  </div>
</section>